/**
 * Helper Import
 */
import StringHelper from "../helpers/StringHelper";
import DateHelper from "../helpers/DateHelper";

/**
 * @class Rules
 *
 * Validator rules
 */
class Rules {

    /**************
     * ATTRIBUTES *
     **************/

    /**
     * Text for an existing SS
     */
    txtisExistSS = "Ce numéro de sécurité social a déjà un compte associé";


    /**
     * Text for an existing SS
     */
    txtVerifySS = "Vérification en cours ...";

    /**
     * Text for unknown SS Number
     */
    txtUnknownSSNumber = 'Numéro de sécurité social non disponible dans nos bases';

    /**
     * Text for invalid Password
     */
    txtInValidPassword = ` Mot de passe invalide`;

    /**
     * Text for Unmatched Email
     */
    txtisPasswordMatch = 'Le mot de passe ne correspond pas';

    /**
     * Text for required fields
     */
    txtRequis = "Champs requis";

    /**
     * Text for number invalid
     */
    txtInvalidNumber = "Nombre incohérent";

    /**
     * Text for invalid num contrat
     */
    txtInvalidNumContrat = 'Numéro de contrat invalide (n° juridique à 8 caractères et différent de 00000000)';

    /**
     * Text for contain invalid char
     */
    txtInvalidChar = 'Contient des caractères incohérents';

    /**
     * Text for invalid date
     */
    txtSameName = 'Le nom ne correspond pas au numéro de sécurité de sociale enregistré';

    /**
     * Text for major
     */
    txtMajor = 'Vous n\'êtes pas majeur';

    /**
     * Text for invalid date
     */
    txtSameDate = 'La date ne correspond pas au numéro de sécurité de sociale enregistré';

    /**
     * Text for invalid email
     */
    txtInvalidEmail = 'E-mail non valide';

    /**
     * Text for unip email
     */
    txtIsUnipMail = 'Ce domaine n\'est pas reservé aux clients, veuillez choisir une adresse personnelle';

    /**
     * Text for email doesnt match
     */
    txtisEmailMatch = 'Cette adresse ne correspond pas à l\'e-mail mentionné précédemment ';

    /**
     * Text for invalid email
     */
    txtisExistEmail = 'E-mail existe déjà';

    /**
     * Text for invalid phone
     */
    txtInvalidPhone = 'Numéro de téléphone incohérent';

    /**
     * Text for invalid postal code
     */
    txtInvalidCp = 'Code postal non valide';

    /**
     * Text for invalid address
     */
    txtInvalidAdress = 'Adresse non valide';

    /**
     * Text for invalid %
     */
    txtInvalidPercent = 'Pourcentage non valide';

    /**
     * Text for % between 1 & 99
     */
    txtInvalidPercentRange = 'Doit être compris entre 1 et 99%';

    /**
     * Text for % > 1
     */
    txtInvalidPercentRangeMin = 'Doit être supérieure à 1%';

    /**
     * Text for % < 100
     */
    txtInvalidPercentRangeMax = 'Doit être inférieur à 100%';

    /**
     * Text for invalid amount
     */
    txtInvalidAmount = 'Montant non valide';

    /**
     * Text for invalid SS Number
     */
    txtInvalidSSNumber = 'Numéro de sécurité sociale non valide';

    /**
     * Text for invalid SS Key
     */
    txtInvalidSSKey = 'Clé incohérente';

    /**
     * Text for date not like num ss
     */
    txtMustBeLikeNumSS = 'Ne correspond pas au n° de sécurité sociale';

    /**
     * Text for invalid date
     */
    txtInvalidDate = 'Date incohérente';

    /**
     * Text for invalid contract
     */
    txtInvalidContract = 'Numéro de contrat incohérent, format attendu : 1234567890123M';

    /**
     * Text for date fields must be after birthdate
     */
    txtDateIsAfterBirth = 'La date doit être postérieure à la date de naissance'

    /**
     * Text for date fields must be before now
     */
    txtDateIsBeforeNow = 'La date doit être antérieure à la date du jour';

    /**
     * Text for date is after previous
     */
    txtdateIsAfterPrevious = 'Doit être postérieure à la période précédente';

    /**
     * Text for date is after start date
     */
    txtdateIsAfterStart = 'Doit être postérieure à la date de début';

    /**
     * Text for date is after last declare date
     */
    txtDateIsAfterLast = 'Doit être postérieure à la date de dernière période déclarée';

    /**
     * Text for date is after date init
     */
    txtDateIsAfterInit = 'Doit être postérieure à la date d\'arrêt initial';

    /**
     * Text for date is after date start company
     */
    txtDateIsAfterStartCompany = 'Doit être antérieure à la date d\'entrée dans l\'entreprise';

    /**
     * Text for missing attached file
     */
    txtMissingAttachment = 'Pièce attendue manquante';

    /**
     * Text file under processing
     */
    txtUnderProcessing = "Veuillez patienter jusqu'à la fin des chargements ou les annuler";

    /**
     * Text for date must be after 1950
     */
    txtDateIsBefore1950 = "Doit être postérieure à 1950";

    /**
     * Text for IPP less than 33%
     */
    txtIppLessThan33 = "Le contrat ne prévoit pas d'indemnisation si le taux est inférieur à 33%";


    /**
     * Text for invalid num juridique
     */
    txtInvalidNumJuridique = 'Numéro juridique invalide';

    /*****************
     * REG EXP RULES *
     *****************/

    /**
     * List of reg exp to test form values
     */
    list = {
        name: "^[A-zÀ-ÿ \\-']+$",
        adresse: "^[0-9A-zÀ-ÿ \\-#°'&()]+$",
        cp: "^[0-9]{5,5}$",
        percent: "^[0-9][0-9]?$|^100$",
        //phone       : "^[+][0-9]{3} [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$",
        phone: "^(?=\\S)(?=.*\\d)[\\d\\s\\+\\(\\)\\-]{8,20}$",
        contrat: "^[0-9]{13}[A-z]$",
        //amount      : "^[+-]?\d{1,3}( \d{3})*(\,\d+)?$",
        // eslint-disable-next-line no-useless-escape
        amount: "\d*(\,\d+)?",
        isAfter1950: "^(([2-9][0-9]{3})|(19[5-9]\\d))-[0-9]{2}-[0-9]{2}$",
        isMoreThan33: "^3[3-9]|[4-9][0-9]|100$",
        nameAlphaNum: "^[A-zÀ-ÿ0-9 \\-']+$",
    };

    /***********
     * GETTERS *
     ***********/

    /**
     * Get the validator reg exp string from key
     */
    reg(key) {
        return 'matchRegexp:' + this.list[key];
    }

    /**
     * Get the regexp string from key
     */
    regExp(key) {
        return this.list[key];
    }

    /********************
     * METHODS VALIDATE *
     ********************/

    /**
     * Check is a password is valid
     */
    isValidPassword = (value) => {

        // force as string
        value += '';
        // return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(|=.*?[#?!@$%^&*-]).{8,}$/.test(value.replace(/ /gi, ''));
        //return /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,150}$/.test(value.replace(/ /gi, ''));
        if (value === '') {
            return true
        } else {
            return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~`¿¡!#$%\^&*€£@+÷=\-\[\]\\';,\/{}\(\)|\\":<>\?\.\_])[a-zA-Z0-9!@#$€£%^&*~`¿¡*+-÷=[\]\\';,\/{}()|":<>?._]{12,}$/.test(value.replace(/ /gi, ''));
        }
    }

    /**
     * Check is a ss num is valid
     */
    isValidSSNum = (value) => {

        // force as string
        value += '';

        return /^[1-9][0-9]{2}(0[1-9]|1[0-2]|20)(2[AB]|[0-9]{2})[0-9]{6}$/.test(value.replace(/ /gi, ''));
    };


    /**
     * check is valid postal code
     * @param value
     * @returns {boolean}
     */
    isValidCP = (value) => {
        // force as string
        value += '';
        if (value !== '') {
            return /^[0-9]{5}$/.test(value.replace(/ /gi, ''));
        }
        return true;
    }

    isValidNumContrat = (value) => {

        // force as string
        value += '';
        if (value.length === 8) {
            if (parseInt(value) === 0) {
                return false
            } else {
                return /^[0-9]{8}$/.test(value.replace(/ /gi, ''));
            }

        } else if(value === '') {
            return true;
        }
    };

    /**
     *
     * @param value
     * @returns {boolean}
     */
    isValidLastName = (value) => {
        return /[^!?,;:§/.%*µ^¨$£¤&~"#'([{|`\\@)\]°=}+]$/.test(value.replace(/ /gi, ''));
    }

    isValidEmail = (value) => {
        // force as string
        value += '';
        return /^(([^<>éèùà^ç~()[\]\\.,;:\s@%&"'|]+(\.[^<>éèùà^ç~()[\]\\.,;:\s@%&"'|]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/.test(value);
    };

    isValidNumJuridique = (value) => {
        // force as string
        value += '';
        return /^[0-9]{8}$/.test(value.replace(/ /gi, ''));
    };

    /**
     * Check is a ss key is valid
     */
    isValidSSKey = (value, ss) => {
        // force as string
        value += '';
        ss += '';
        return /^[0-9]{2}$/.test(value) && parseInt(value) === (97 - ((StringHelper.unformatSSNum(ss).replace("2A", "19").replace("2B", "18")) % 97));
    };

    /**
     * Check if date naiss match ss
     */
    isValidNumDateNaiss = (value, ss) => {
        if (typeof value !== 'string' || typeof ss !== 'string') {
            return false; // or handle the error as needed
        }
        return (ss.substr(1, 2) === value.substr(2, 2) && ss.substr(3, 2) === value.substr(5, 2));
    }

    /**
     * check if the date is before now
     */
    isBeforeNowStrict = (value) => {
        if (value === '') return true;
        return new Date(value.substr(0, 4), value.substr(5, 2) - 1, value.substr(8, 2), 0, 0, 0) < new Date();
        //&& value.substr(0,4)>1950
    }

    /**
     * check if the date is before now
     */
    isBeforeNow = (value) => {
        if (value === undefined || value === '' || value === 'Undefined') return true;
        return DateHelper.InputToJSDate(value) <= new Date();
        // && value.substr(0,4)>1950
    }


    /**
     * check if the date is valid
     */
    isValidDate = (value) => {

        if (value === '') return true;

        var date = DateHelper.InputToJSDate(value);

        if (DateHelper.InputToJSDate(value) === false) return false;

        var values = value.split('-');

        if (parseInt(values[1]) !== parseInt(date.getMonth() + 1)) return false;

        if (parseInt(values[2]) !== parseInt(date.getDate())) return false;

        return true;
    }

    /***********
     * METHODS *
     ***********/

    /**
     * format phone number input
     */
    getFormatedPhone = (value) => {

        let originalValue = value.replace(/[^+0-9]/gi, '');

        // If empty exit
        if (originalValue === '') return '';

        // CASE +33
        /*
         // Add +33 at start if missing
         if('+'!==originalValue[0]) originalValue='+33' + originalValue;

         // remove the 0 in +330 which is meaningless
         if(originalValue==='+330') originalValue='+33';

         // Format tel
         originalValue = StringHelper.formatTel(originalValue);

         // Check length
         if(originalValue.length>16) originalValue=originalValue.substr(0,16);
         */

        // Add 0 at start if missing
       // if ('0' !== originalValue[0]) originalValue = '0' + originalValue;

        // Format tel
       // originalValue = StringHelper.formatTel(originalValue);

        // Check length
        if (originalValue.length > 20) originalValue = originalValue.substr(0, 20);

        return originalValue;
    }

    getOnlyNumbers = (value) => {
        let originalValue = value.replace(/[^+0-9]/gi, '');
        // If empty exit
        if (originalValue === '') return '';

        return originalValue;
    }

    /**
     * format ss num input
     */
    getFormatedNumSS = (value) => {

        let originalValue = StringHelper.unformatSSNum(value);

        // If empty exit
        if (originalValue === '') return '';

        // Format ss num
        originalValue = StringHelper.formatSSNum(originalValue);

        // Check length
        if (originalValue.length > 18) originalValue = originalValue.substr(0, 18);

        return originalValue;
    }


    getFormatedNumContrat = (value) => {

        let originalValue = StringHelper.unformatSSNum(value);

        // If empty exit
        if (originalValue === '') return '';

        // Format ss num
        originalValue = StringHelper.formatSSNum(originalValue);

        // Check length
        if (originalValue.length > 18) originalValue = originalValue.substr(0, 18);

        return originalValue;
    }

    /**
     * format money input
     */
    getFormatedMoney = (value) => {

        let originalValue = StringHelper.unformatMoney(value);

        // If empty exit
        if (originalValue === '') return '';

        return StringHelper.formatMoney(originalValue);
    }

    /**
     * Capitalize the text
     */
    getCapitalize = (value) => {
        return StringHelper.capitalize(value);
    }

    /**
     * Lower case the text
     */
    getLowercase = (value) => {
        return value.toLowerCase();
    }

    /**
     * Upper case the text
     */
    getUpperCase = (value) => {
        return value.toUpperCase();
    }

    /**
     * Regular case the text
     */
    getRegularCase = (value) => {
        return value;
    }

}

/**********
 * EXPORT *
 **********/

export default new Rules();

